import { Divider, Grid, IconButton, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { Box } from '@mui/system';
import { useSelector } from 'react-redux';
import { TemplateSelector } from './components/TemplateSelector';
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import { useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';

export default function SendTemplates() {
  const organization = useSelector((state) => state.app.organization);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const template =
    (organization &&
      organization.templates &&
      organization.templates.filter((template) => template.isActive)) ||
    [];

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    bgcolor: 'background.paper',
    boxShadow: 55,
    p: 4,
  };

  return template ? (
    <>
      <Divider sx={{ width: '100%' }} />
      <Grid item sm={12}>
        <Grid item sm={12}>
          <Box>
            <Typography variant="h4" sx={{ display: 'flex', alignItems: 'center' }}>
              Envío manual de notificaciones de WhatsApp
              <IconButton size="small" onClick={handleOpen} sx={{ ml: 1 }}>
                <InfoSharpIcon fontSize="small" />
              </IconButton>
            </Typography>
            <Typography variant="h6" sx={{ mt: 2 }}>
              Pasos:
            </Typography>
            <Box component="ol" pl={3} sx={{ listStyleType: 'decimal' }}>
              <Typography component="li" variant="body1" sx={{ mt: 1 }}>
                Seleccionar la plantilla/template que desea utilizar.
              </Typography>
              <Typography component="li" variant="body1" sx={{ mt: 1 }}>
                Seleccionar a qué estado debe pasar el chat una vez enviada la notificación.
              </Typography>
              <Typography component="li" variant="body1" sx={{ mt: 1 }}>
                Descargar el archivo modelo de la plantilla seleccionada.
              </Typography>
              <Typography component="li" variant="body1" sx={{ mt: 1 }}>
                Completar todos los datos necesarios en el archivo modelo.
              </Typography>
              <Typography component="li" variant="body1" sx={{ mt: 1 }}>
                Subir el archivo modelo y hacer click en el botón "ENVIAR ARCHIVO".
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography variant="h6" sx={{ mt: 0.5, display: 'flex', alignItems: 'center' }}>
              <ErrorIcon sx={{ mr: 1, color: 'primary.main' }} />
              IMPORTANTE:
            </Typography>
            <Box component="ol" pl={3} sx={{ listStyleType: 'decimal' }}>
              <Typography component="li" variant="body1" sx={{ mt: 1, fontWeight: 'lighter' }}>
                El proceso de envío es automático pero no inmediato, por lo que las notificaciones
                se enviarán durante el transcurso del día.
              </Typography>
              <Typography component="li" variant="body1" sx={{ mt: 1, fontWeight: 'lighter' }}>
                En el archivo csv, la columna con el dato de celulares debe tener{' '}
                <strong>formato de número </strong>
                sin decimales.
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item sm={6}>
          <Box>
            <TemplateSelector />
          </Box>
        </Grid>
      </Grid>
      <Divider sx={{ width: '100%', mt: 2 }} />
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={open}>
            <Box sx={style}>
              <Typography Typography sx={{ fontSize: 24 }}>
                Información del envio manual de plantillas
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                Recuerde completar todas las columnas con la información requerida
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                Ejemplo de envío no válido:
              </Typography>
              <img
                src="https://firebasestorage.googleapis.com/v0/b/prestobots-296019.appspot.com/o/template_media%2Fsample_fail.png?alt=media&token=5c8a600b-9596-4f32-8a63-31e5453af489"
                srcSet="https://firebasestorage.googleapis.com/v0/b/prestobots-296019.appspot.com/o/template_media%2Fsample_fail.png?alt=media&token=5c8a600b-9596-4f32-8a63-31e5453af489 1.6x"
                style={{ maxWidth: '100%', height: 'auto' }}
              />
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                ⚠️ Importante: Si el archivo cargado no sigue las instrucciones, el envío de
                plantillas puede fallar
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </>
  ) : null;
}
